<script>
    import { random } from 'lodash';
    export let isFinalSceneActive;
    export let survivors;
    export let victims;
    export let onBookClick;
    export let showPhotoAlbumInfo;
</script>

<div class="navigation-container">
    <div class="placeholder"/>
    <div class="navigation">
         {#if !isFinalSceneActive}
            <div class="matched-cards">
                <div>
                    {#each victims as image}
                        <img
                            class="matched-image"
                            src={image.frontImgPath}
                            alt=""
                            style={
                                `transform: rotate(${random(-20, 20)}deg) translate(${random(-10, 10)}px,${random(-20,5)}px)`
                            }
                        />
                    {/each}
                </div>
            </div>
        {/if} 

        <img
            src="images/extra_elements/borito.png"
            class="blue-book"
            on:click={() => onBookClick()}
            alt=""
            title="új lapok"
        />
        
        {#if !isFinalSceneActive}
            <div class="matched-cards">
                <div>
                    {#each survivors as image, index}
                        <img
                            class="matched-image"
                            src={image.frontImgPath}
                            alt=""
                            style={
                                `transform: rotate(${random(-20, 20)}deg) translate(${random(-10, 10)}px,${random(-10,10)}px)`
                            }
                        />
                    {/each}
                </div>
            </div>
        {/if} 
    </div>
    <img
        class="ash-tray-img"
        src="images/extra_elements/hamutarto.png"
        alt=""
        title="fotóalbum"
        on:click={() => showPhotoAlbumInfo()}
    />
</div>


<style>
    .navigation-container {
        display: flex;
        position: absolute;
        bottom: 50px;
        width: 100%;
    }
    .placeholder {
        width: 20%;
    }
    .ash-tray-img {
        position: absolute;
        bottom: -9vw;
        left: -9vw;
        width: 20vw;
        cursor: pointer;
    }
    .navigation {
        display: flex;
        justify-content: space-around;
        text-align: center;
        width: 80%;
    }
    .matched-cards {
        display: flex;;
        min-width: 200px;
    }
    .blue-book {
        height: 27vh;
        transform: rotate(5deg);
        cursor: pointer;
    }
    .matched-image {
        height: 33vh;
        max-height: 260px;
        position: absolute;
        border-radius: 8%;
    }
</style>
